import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  key: 0,
  class: "text-[10px] px-1.5 py-0.5 rounded shrink-0 bg-red-50 text-red-600 font-medium"
};
const _hoisted_3 = {
  key: 0
};
import { ref, computed } from 'vue';
import { ArrowRight, ArrowDown, Folder, FolderOpened, MoreFilled, Edit, Right, Lock, Delete } from '@element-plus/icons-vue';
export default {
  __name: 'FolderTreeNode',
  props: {
    node: {
      type: Object,
      required: true
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  emits: ['select', 'edit', 'delete', 'move', 'acl', 'refresh'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const expanded = ref(props.depth < 2);
    const hasChildren = computed(() => props.node.children?.length > 0);
    const disabled = computed(() => props.node.status === 0 || props.node.status === 'DISABLED');
    const canManage = computed(() => !props.node.pathOnly && !disabled.value && props.node.permissionLevel === 'MANAGE');
    const paddingLeftPx = computed(() => `${8 + props.depth * 16}px`);
    const iconClass = computed(() => {
      if (props.node.pathOnly) return 'text-slate-300';
      if (props.node.permissionLevel === 'MANAGE') return 'text-amber-500';
      return 'text-slate-400';
    });
    function handleClick() {
      if (!props.node.pathOnly && !disabled.value) {
        emit('select', props.node);
      }
    }
    function handleDelete() {
      emit('delete', props.node);
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_FolderTreeNode = _resolveComponent("FolderTreeNode", true);
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: _normalizeClass(["tree-node flex items-center gap-1.5 pr-2 cursor-pointer select-none group rounded-md mx-1 transition-all duration-150", [__props.selectedId === __props.node.id ? 'bg-primary-50/80 text-primary-700' : 'hover:bg-slate-100/60 text-slate-600', __props.node.pathOnly || disabled.value ? 'opacity-50' : '']]),
        style: _normalizeStyle({
          paddingLeft: paddingLeftPx.value
        }),
        onClick: handleClick
      }, [_createElementVNode("span", {
        class: _normalizeClass(["expand-arrow w-4 h-4 flex items-center justify-center shrink-0", {
          'invisible': !hasChildren.value
        }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => expanded.value = !expanded.value, ["stop"]))
      }, [_createVNode(_component_el_icon, {
        size: 12
      }, {
        default: _withCtx(() => [!expanded.value ? (_openBlock(), _createBlock(_unref(ArrowRight), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(ArrowDown), {
          key: 1
        }))]),
        _: 1
      })], 2), _createVNode(_component_el_icon, {
        size: 16,
        class: _normalizeClass(["shrink-0", iconClass.value])
      }, {
        default: _withCtx(() => [expanded.value && hasChildren.value ? (_openBlock(), _createBlock(_unref(FolderOpened), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(Folder), {
          key: 1
        }))]),
        _: 1
      }, 8, ["class"]), _createElementVNode("span", {
        class: "flex-1 truncate text-[13px] font-medium",
        title: __props.node.name
      }, _toDisplayString(__props.node.name), 9, _hoisted_1), disabled.value ? (_openBlock(), _createElementBlock("span", _hoisted_2, " 禁用 ")) : _createCommentVNode("", true), canManage.value ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        trigger: "click",
        "hide-on-click": true,
        class: "shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-150"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('edit', __props.node))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 14
            }, {
              default: _withCtx(() => [_createVNode(_unref(Edit))]),
              _: 1
            }), _cache[11] || (_cache[11] = _createTextVNode(" 编辑 ", -1))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('move', __props.node))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 14
            }, {
              default: _withCtx(() => [_createVNode(_unref(Right))]),
              _: 1
            }), _cache[12] || (_cache[12] = _createTextVNode(" 移动 ", -1))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('acl', __props.node))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 14
            }, {
              default: _withCtx(() => [_createVNode(_unref(Lock))]),
              _: 1
            }), _cache[13] || (_cache[13] = _createTextVNode(" 权限配置 ", -1))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: handleDelete
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 14
            }, {
              default: _withCtx(() => [_createVNode(_unref(Delete))]),
              _: 1
            }), _cache[14] || (_cache[14] = _createElementVNode("span", {
              class: "text-red-500"
            }, "删除", -1))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", {
          class: "w-6 h-6 flex items-center justify-center rounded hover:bg-slate-200/60 transition-colors",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [_createVNode(_component_el_icon, {
          size: 14,
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(MoreFilled))]),
          _: 1
        })])]),
        _: 1
      })) : _createCommentVNode("", true)], 6), expanded.value && hasChildren.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.children, child => {
        return _openBlock(), _createBlock(_component_FolderTreeNode, {
          key: child.id,
          node: child,
          "selected-id": __props.selectedId,
          depth: __props.depth + 1,
          onSelect: _cache[5] || (_cache[5] = $event => _ctx.$emit('select', $event)),
          onEdit: _cache[6] || (_cache[6] = $event => _ctx.$emit('edit', $event)),
          onDelete: _cache[7] || (_cache[7] = $event => _ctx.$emit('delete', $event)),
          onMove: _cache[8] || (_cache[8] = $event => _ctx.$emit('move', $event)),
          onAcl: _cache[9] || (_cache[9] = $event => _ctx.$emit('acl', $event)),
          onRefresh: _cache[10] || (_cache[10] = $event => _ctx.$emit('refresh'))
        }, null, 8, ["node", "selected-id", "depth"]);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};